var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIlFreeway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 181.769 132.556",
    height: 501,
    width: 687,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 181.504,
    height: 132.292,
    x: 0.132,
    y: 0.132,
    rx: 23.813,
    ry: 23.813,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.265
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 23.944793,8.0697922 c -8.79475,0 -15.8750008,7.0802508 -15.8750008,15.8750008 v 84.666667 c 0,8.79475 7.0802508,15.875 15.8750008,15.875 H 157.82396 c 8.79475,0 15.875,-7.08025 15.875,-15.875 V 23.944793 c 0,-8.79475 -7.08025,-15.8750008 -15.875,-15.8750008 z m 66.939585,9.7895838 64.822922,7.9375 7.9375,40.481251 -7.9375,40.481253 -64.822922,7.9375 -65.352085,-7.9375 -7.408334,-40.481253 7.408334,-40.481251 z",
    fill: "#0000FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlFreeway);
export default __webpack_public_path__ + "static/media/il-freeway.9cba35eaf385ead674f6af9467108c88.svg";
export { ForwardRef as ReactComponent };